import classNames from 'classnames';
import { LegendsFilterWrapper } from 'components/legends-filter/legends-filter-wrapper.js';
import { useEffect, useState } from 'react';
import { ICheckedFilter, IMapKey, IRadioFilter } from 'types/location.js';
import { LegendButton } from './legend-button.js';
import { hasLegend, LegendsEnum } from './legend-types.js';
import { LegendsKeys } from './legends-keys.js';

export interface ILegendProps {
  keys?: Array<IMapKey>;
  // Filter props
  checkboxFilters?: Array<ICheckedFilter>;
  checkboxFilterOnClick?: (filter: ICheckedFilter) => void;
  // Radio Button Marker Type props
  radioFilters?: Array<IRadioFilter>;
  radioActiveFilter?: string[];
  radioFilterOnClick?: (radioFilter: string) => void;
  checkBoxFilterLabel?: string;
  radioFilterLabel?: string;
}

export const Legends = ({
  keys,
  checkboxFilters = [],
  checkBoxFilterLabel,
  checkboxFilterOnClick = (_: ICheckedFilter) => 0,
  radioFilters = [],
  radioFilterLabel,
  radioActiveFilter,
  radioFilterOnClick = (_: string) => 0,
}: ILegendProps) => {
  const [selected, setSelectedLegend] = useState<LegendsEnum>();

  const selectLegend = (selectedLegend: LegendsEnum | undefined) => {
    setSelectedLegend((prevSelectedLegend) => {
      let newSelectedLegend = selectedLegend;

      // If the same one is clicked then deselect it
      if (prevSelectedLegend === selectedLegend) {
        newSelectedLegend = undefined;
      }

      return newSelectedLegend;
    });
  };

  useEffect(() => {
    selectLegend(undefined);
  }, [keys]);

  return (
    <>
      {hasLegend(keys) && (
        <LegendButton onClick={selectLegend} icon="key" label="Keys" active={selected} index={LegendsEnum.Keys} />
      )}
      {hasLegend(checkboxFilters, radioFilters) && (
        <LegendButton
          onClick={selectLegend}
          icon="filter"
          label="Filters"
          active={selected}
          index={LegendsEnum.Filters}
        />
      )}
      {/* Active Legend */}
      {selected && (
        <div
          className="u-posAbs"
          style={{
            right: '40px',
            top: 0,
            backgroundColor: 'white',
            width: '300px',
            borderRadius: '4px',
            padding: '2px',
          }}
        >
          {selected === LegendsEnum.Keys && (
            <div className={classNames('Legend-body', { 'Legend-body--noPadding': keys?.length !== 1 })}>
              <LegendsKeys keys={keys} />
            </div>
          )}

          {selected === LegendsEnum.Filters && (
            <div className="Legend-body">
              <LegendsFilterWrapper
                checkboxFilters={checkboxFilters}
                checkboxFilterOnClick={checkboxFilterOnClick}
                checkBoxFilterLabel={checkBoxFilterLabel}
                radioFilters={radioFilters}
                radioActiveFilter={radioActiveFilter}
                radioFilterOnClick={radioFilterOnClick}
                radioFilterLabel={radioFilterLabel}
              />
            </div>
          )}

          <div className="Legend-footer" onClick={() => selectLegend(undefined)}>
            Close
          </div>
        </div>
      )}
    </>
  );
};
